import { useRef, useState } from "react";

interface LongPressRefreshProps {
  holdMs?: number;
  onComplete?: () => void;
  children: React.ReactNode;
}

export function LongPressRefresh({
  holdMs = 600,
  onComplete = () => window.location.reload(),
  children
}: LongPressRefreshProps) {
  const timeoutRef = useRef<number | null>(null);
  const intervalRef = useRef<number | null>(null);
  const [progress, setProgress] = useState(0);

  const start = () => {
    if (timeoutRef.current !== null) return;

    const startTime = Date.now();

    intervalRef.current = window.setInterval(() => {
      const elapsed = Date.now() - startTime;
      const p = Math.min(1, elapsed / holdMs);
      setProgress(p);
    }, 16);

    timeoutRef.current = window.setTimeout(() => {
      cleanup();
      onComplete();
    }, holdMs);
  };

  const cleanup = () => {
    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    if (intervalRef.current !== null) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    setProgress(0);
  };

  // Interpolate color from white → grey
  const greyValue = Math.round(255 - progress * 120); // 255 → ~135
  const color = `rgb(${greyValue}, ${greyValue}, ${greyValue})`;

  return (
    <div
      onTouchStart={start}
      onTouchEnd={cleanup}
      onTouchCancel={cleanup}
      onMouseDown={start}
      onMouseUp={cleanup}
      onMouseLeave={cleanup}
      style={{
        color: color,
        transition: progress === 0 ? "background-color 150ms ease-out" : "none",
        userSelect: "none",
        touchAction: "manipulation",
        cursor: "pointer"
      }}
      title="Drücken und halten zum neu laden"
    >
      {children}
    </div>
  );
}
